import { i18n } from "./i18n";

// Only call for interface text, never for messages or customer-entered content.
export const translateUi = (text, values = {}) => i18n.t(text, {
  ...values,
  ns: "interface",
  keySeparator: false,
  nsSeparator: false,
  defaultValue: text,
  interpolation: { escapeValue: false },
});
